import { createContext } from 'react'
import type { ToastItemProps } from '../components/toast2/toast-types'

export const ToastContext = createContext({
  removeToast: (_: string) => {},
  sendToast: (_: ToastItemProps) => {},
})
